export default [
// {
//    "title":"MotionLogic Demo Video",
//    "author_name":"Alex McClung",
//    "created_at":"2023-08-15T15:00:00Z",
//    "updated_at":"2023-08-15T15:00:00Z",
//    "tags":[
//       "Computer Vision",
//       "Industrial Automation",
//       "MotionLogic",
//       "Demo"
//    ],
//    "content_path":"https://www.youtube.com/watch?v=example",
//    "thumbnail_path":"/images/process_segmentation.png",
//    "type": "media",
//    "category": "Video",
//    "description": "See how MotionLogic transforms industrial workflows with computer vision."
// },
 {
    "title":"Data Process Optimisation",
    "author_name":"Alex McClung",
    "created_at":"2022-10-11T15:00:00Z",
    "updated_at":"2022-10-11T15:00:00Z",
    "tags":[
       "Machine Learning",
       "Industry 4.0",
       "Optimisation",
       "Industrial Processes"
    ],
    "content_path":"data_to_wisdom_part1.md",
    "thumbnail_path":"/images/thumbnail_process.png",
    "type": "blogPosts",
    "category": "Blog Post",
    "description": "Understanding the journey from raw data to actionable wisdom in industrial contexts."
 },
{
   "title":"Observation, Analysis, and Enablement",
   "author_name":"Alex McClung",
   "created_at":"2022-10-11T15:00:00Z",
   "updated_at":"2022-10-11T15:00:00Z",
   "tags":[
      "Machine Learning",
      "Industry 4.0",
      "Optimisation",
      "Industrial Processes"
   ],
   "content_path":"data_to_wisdom_part3.md",
   "thumbnail_path":"/images/thumbnail_logistics.png",
   "type": "blogPosts",
   "category": "Blog Post",
   "description": "Deep dive into observation, analysis, and enablement strategies for industrial data."
},
{
   "title":"Reducing Risk in Machine Learning Deployments",
   "author_name":"Alex McClung",
   "created_at":"2023-05-30T15:00:00Z",
   "updated_at":"2023-05-30T15:00:00Z",
   "tags":[
      "Machine Learning",
      "Industry 4.0",
      "Optimisation",
      "Industrial Processes"
   ],
   "content_path":"reduce_risk_ml.md",
   "thumbnail_path":"/images/thumbnail_reduce_risk.png",
   "type": "blogPosts",
   "category": "Blog Post",
   "description": "Best practices for minimizing risks when deploying ML solutions in production."
}
]